import 'focus-visible';
import LazyLoad from 'vanilla-lazyload';
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress'
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { renderPartials } from './partial';
import { renderMessages } from './message';
import { renderBanner } from './features';
import Message from 'Web/Shared/Message.vue';
import './features/facebook';

dayjs.locale('de');

InertiaProgress.init({
  delay: 40,
  color: '#a855f7',
});

window.lazyLoad = new LazyLoad({
  //
});

document.addEventListener('inertia:navigate', () => {
  window.lazyLoad.update();
});

document.addEventListener('inertia:finish', () => {
  window.lazyLoad.update();
});

createInertiaApp({
  resolve: name => require(`./components/Web/Pages/${name}`),
  setup: ({ el, app, props, plugin }) => {
    const vueApp = createApp({
      render: () => [
        h(app, props),
        renderBanner(),
        renderPartials(),
        renderMessages(Message),
      ]
    });

    vueApp.mixin({
      methods: {
        route: window.route,
        dayjs,
      }
    });

    vueApp.use(plugin);

    vueApp.mount(el);

    window.lazyLoad.update();
  },
});
